import React from "react";

const Available = (props) => {
	let marker = props.marker
	// console.log(marker.markerId, "reloaded", props.source);
	if (marker.type === "gjenvinningsstasjoner") {

		if (!marker.today.closed_all_day) {
			return(
				<div className="station__content__open">
					<div className="station__content__open__icon">
						<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
							<circle id="Ellipse_103" data-name="Ellipse 103" cx="7" cy="7" r="7" fill="#86bc25"/>
						</svg>
					</div>
					<span className="station__content__open__hours">Åpent i dag: {marker.today.opens} - {marker.today.closes}</span>
				</div>
			)
		} else {
			console.log("Stengt", props.source);
			return(
			<div className="station__content__open">
				<div className="station__content__open__icon">
					<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
						<circle id="Ellipse_103" data-name="Ellipse 103" cx="7" cy="7" r="7" fill="#eb4949"/>
					</svg>
				</div>
				<span className="station__content__open__hours">Stengt</span>
			</div>
			)

		}
	}
	return '';
}

const calculateDistance = (pos1, pos2) => {
	let user = {
		lat: pos1.lat,
		lng: pos1.lng
	};
	let marker = {
		lat: pos2.lat,
		lng: pos2.lng
	}

	if ((user.lat == marker.lat) && (user.lng == marker.lng)) {
		return 0;
	} else {
		var radUserLat = Math.PI * user.lat/180;
		var radMarkerLat = Math.PI * marker.lat/180;
		var theta = user.lng-marker.lng;
		var radtheta = Math.PI * theta/180;
		var dist = Math.sin(radUserLat) * Math.sin(radMarkerLat) + Math.cos(radUserLat) * Math.cos(radMarkerLat) * Math.cos(radtheta);
		if (dist > 1) {
			dist = 1;
		}
		dist = Math.acos(dist);
		dist = dist * 180/Math.PI;
		dist = dist * 60 * 1.1515;
		dist = dist * 1.609344;
		return dist.toFixed(2);
	}
}

const Distance = (props) => {;
	return(
		<div className="station__content__distance" data-distance={props.distance}>
			<div className="station__content__distance__icon">
				<svg xmlns="http://www.w3.org/2000/svg" width="11.762" height="16.99" viewBox="0 0 11.762 16.99">
					<path id="Icon_ionic-ios-pin" data-name="Icon ionic-ios-pin" d="M13.756,3.375a5.684,5.684,0,0,0-5.881,5.46c0,4.247,5.881,11.529,5.881,11.529s5.881-7.282,5.881-11.529A5.684,5.684,0,0,0,13.756,3.375Zm0,7.8a1.915,1.915,0,1,1,1.915-1.915A1.916,1.916,0,0,1,13.756,11.171Z" transform="translate(-7.875 -3.375)" fill="#033556"/>
				</svg>
			</div>
			<span className="station__content__distance__unit">{props.distance} km</span>
		</div>
	);
}

const ensure_slug = (string) => {
	if (!string) return;
	var slug = string.toLowerCase();
	var from = "åøæ";
	var to = "aoae";

	for (var i = 0, l = from.length; i < l; i++) {
		if (i+1 < from.length) {
			slug = slug.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
		} else {
			slug = slug.replace(new RegExp(from.charAt(i), "g"), 'ae');
		}
	}
	return slug;
}

export {Available, calculateDistance, Distance, ensure_slug}
